import { render, staticRenderFns } from "./power-transformer-manage.vue?vue&type=template&id=0d34759b&scoped=true&"
import script from "./power-transformer-manage.vue?vue&type=script&lang=js&"
export * from "./power-transformer-manage.vue?vue&type=script&lang=js&"
import style0 from "./power-transformer-manage.vue?vue&type=style&index=0&id=0d34759b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d34759b",
  null
  
)

export default component.exports